import { render, staticRenderFns } from "./TaskList.html?vue&type=template&id=4df15ed8&scoped=true&"
import script from "./TaskList.vue?vue&type=script&lang=js&"
export * from "./TaskList.vue?vue&type=script&lang=js&"
import style0 from "./TaskList.scss?vue&type=style&index=0&id=4df15ed8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df15ed8",
  null
  
)

export default component.exports